import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { errorMessage, type MyOrders } from "@/lib/driver";
import { OrderCard } from "@/components/OrderCard";
import { Empty, ErrorBox, Loading } from "@/components/ui";

const SECTIONS: { key: keyof MyOrders; title: string; empty: string }[] = [
  { key: "accepted", title: "Acceptées", empty: "Aucune commande acceptée en attente." },
  { key: "inProgress", title: "En cours de livraison", empty: "Aucune livraison en cours." },
  { key: "delivered", title: "Livrées", empty: "Aucune livraison terminée." },
  { key: "failed", title: "Échecs de livraison", empty: "Aucun échec de livraison." },
];

export default function MyOrdersPage() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["mine"],
    queryFn: () => api<MyOrders>("/orders/mine"),
    refetchInterval: 30_000,
  });

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-extrabold tracking-tight">Mes commandes</h1>
      {isLoading ? (
        <Loading />
      ) : error || !data ? (
        <ErrorBox message={errorMessage(error)} onRetry={() => refetch()} />
      ) : (
        SECTIONS.map(({ key, title, empty }) => (
          <section key={key} className="space-y-3" aria-label={title}>
            <h2 className="text-sm font-bold tracking-wide text-muted uppercase">
              {title} ({data[key].length})
            </h2>
            {data[key].length === 0 ? (
              <Empty>{empty}</Empty>
            ) : (
              <div className="grid gap-3 md:grid-cols-2">
                {data[key].map((o) => (
                  <OrderCard key={o.id} order={o} assigned highlight={key === "inProgress"} />
                ))}
              </div>
            )}
          </section>
        ))
      )}
    </div>
  );
}
